<template>
  <beva-select
    v-bind="$attrs"
    :items="items"
    label="name"
    :loading="loading"
    :meta="meta"
    searchable
    track-by="id"
    @asyncFetch="handleInfiniteScroll"
    @asyncSearch="debouncedSearch"
  >
    <template v-if="$slots.option"
              #option="{ option: { option } }">
      <slot name="option"
            :option="option" />
    </template>
    <template v-if="$slots.errors"
              #errors>
      <slot name="errors" />
    </template>
    <template v-else-if="error"
              #errors>
      {{ error }}
    </template>
  </beva-select>
</template>

<script>
  import BevaSelect from '@/components/SharedComponents/BevaSelect/BevaSelect.vue';
  import { debounceHelper } from '@/helpers/debounce/debounce.helper';

  const cache = new Map();

  export default {
    name: 'BevaApiSelector',
    components: {
      BevaSelect,
    },
    props: {
      apiClass: {
        type: Object,
        required: true,
        validator: (value) => {
          return typeof value.get === 'function';
        },
      },
      error: {
        type: String,
        default: '',
      },
      searchKey: {
        type: String,
        default: 'search',
      },
      cache: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        items: [],
        loading: false,
        meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 10,
          to: 1,
          total: 10,
        },
        page: 1,
        search: '',
      };
    },
    computed: {
      debouncedSearch() {
        return debounceHelper((query) => this.handleSearch(query), 500);
      },
    },
    methods: {
      handleInfiniteScroll() {
        this.page++;
        this.loadData();
      },
      handleSearch(query) {
        this.search = query;
        this.page = 1;
        this.items = [];
        this.loadData();
      },
      loadData() {
        const cacheKey = `${this.search}-${this.page}`;

        // Check cache first
        if (this.cache && cache.has(cacheKey)) {
          const { data, meta } = cache.get(cacheKey);
          this.items = data;
          this.meta = meta;
          return;
        }

        this.loading = true;
        this.apiClass
          .get({ params: { page: this.page, [this.searchKey]: this.search } })
          .then(({ data }) => {
            this.items = [...this.items, ...data.data];
            this.meta = data.meta;
            this.page = data.meta.current_page;
            this.cache && cache.set(cacheKey, data);
          })
          .catch((error) => {
            console.error('Error loading data:', error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    created() {
      this.loadData();
    },
  };
</script>
